export const SET_PREVIEW_FOR = 'REPORTING_SET_PREVIEW_FOR';

export const setPreviewFor = previewFor => ({
  type: SET_PREVIEW_FOR,
  previewFor,
});
